import type { ThunkDispatch } from 'editor/src/store/hooks';

import { RootState } from 'editor/src/store';

import { setLivePreviewScenesAction } from '../slice';
import { LivePreviewScenesPayload } from '../types';

// Mirrors the stale-payload guard in setSpreadBackgroundsOperation: a payload
// for a product that is no longer selected must not overwrite current state.
const setLivePreviewScenesOperation =
  (payload: LivePreviewScenesPayload) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    const { selectedProductUid } = getState().variants;
    if (selectedProductUid && payload.productUid && payload.productUid !== selectedProductUid) {
      return;
    }
    dispatch(setLivePreviewScenesAction(payload));
  };

export default setLivePreviewScenesOperation;
